(function() {
    angular
        .module('ShargoApp')
        .controller('NewsLetterController',function ($http, $scope, Configuration) {
            $scope.submit = function() {
                $scope.formError = false;
                $scope.success = false;
                if ($scope.email === undefined || $scope.email === "") {
                    $scope.formError = true;
                    $scope.formErrorMsg = "Por favor, introduzca un email valido";
                    return;
                }
                $http.post(Configuration.apiUrl + "/newsletter", {
                    email: $scope.email
                }).then(function() {
                    $scope.success = true;
                    $scope.email = "";
                }, function() {
                    $scope.formError = true;
                    $scope.formErrorMsg = "Por favor, introduzca un email valido";
                });
            };
        });
})();